module.exports = __webpack_public_path__ + "img/upload.5c703d75.png";